import {
  DEALS,
  AUBAINES,
  NOUVEAU,
  HOMMES,
  FEMMES,
  UNISEX,
  UNISEXE,
  CLEARANCE,
  LIQUIDATION,
  ECONOMISEZ,
} from '@utils/plp/constants';

export const knownPromotions: Record<string, string[]> = {
  en: [DEALS, CLEARANCE, 'sale', 'new-arrivals'],
  fr: [AUBAINES, LIQUIDATION, 'economisez', NOUVEAU],
};

const knownFilters: Record<string, string[]> = {
  en: ['mens', 'womens', UNISEX, 'kids', ...knownPromotions.en],
  fr: [HOMMES, FEMMES, UNISEXE, 'enfants', ...knownPromotions.fr],
};

export const urlIsKnownFilter = (categorySlug: string, locale: string) => {
  for (const filter of knownFilters[locale]) {
    if (categorySlug.endsWith(`/${filter}`)) {
      return true;
    }
  }
  return false;
};

export const slugIsKnownFilter = (slug: string, locale = 'en') => {
  return knownFilters[locale]?.includes(slug);
};

export const removeKnownFilterFromCategoryPath = (
  categoryPath: string,
  locale: string,
  separator: string
) => {
  let categoryUrl = categoryPath;
  const filtersByLocale = knownFilters[locale] || [];
  const categoryParts = categoryPath.split(separator).reverse();

  if (categoryParts.length) {
    // 2 is the maximum number of filters (/mens/deals)
    for (let i = 0; i < 2; i++) {
      if (filtersByLocale.includes(categoryParts[i]?.toLowerCase())) {
        categoryUrl = categoryUrl.slice(
          0,
          -(categoryParts[i].length + separator.length)
        );
      }
    }
  }

  return categoryUrl;
};
